import {
  captureException as captureExceptionSentry,
  captureMessage as captureMessageSentry,
} from '@sentry/react';

/**
 * Capture an exception and send it to Sentry, with optional additional context.
 * @param exception - The exception to capture.
 * @param context - Additional context to include with the exception.
 */
export function captureException(exception: unknown, context?: Record<string, unknown>): void {
  captureExceptionSentry(exception, context);
}

/**
 * Capture a message and send it to Sentry, with optional additional context.
 * @param message - The message to capture.
 * @param context - Additional context to include with the message.
 */
export function captureMessage(message: string, context?: Record<string, unknown>): void {
  captureMessageSentry(message, context);
}
